<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="50"
                  :options.sync="params.options" :server-items-length="params.total"
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [20, 50, 100]}">
      <template v-slot:top>
        <v-toolbar flat>
          <v-container v-if="isCount">
            <v-chip class="ma-2" color="primary">总订单: {{ count.orders }}</v-chip>
            <v-chip class="ma-2" color="indigo" text-color="white">总销量: {{ count.sales }}</v-chip>
            <v-chip class="ma-2" color="green" text-color="white">已付款: {{ count.payed }}</v-chip>
            <v-chip class="ma-2" color="warning" text-color="white">已换货: {{ count.replaced }}</v-chip>
            <v-chip class="ma-2">已取消: {{ count.canceled }}</v-chip>
          </v-container>
          <v-spacer/>
          <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                        single-line hide-details clearable v-model="params.filters.search" @click:append="getData"
                        @click:clear="clear" @keydown.enter="getData"></v-text-field>
          <v-btn icon @click="openFilterDialog">
            <v-icon>mdi-filter-menu</v-icon>
          </v-btn>
          <v-btn icon @click="getData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.productImageUrl="{ item }">
        <img alt="商品主图" :src="item.productImageUrl" height="80" width="80"/>
      </template>
      <template v-slot:item.asin="{ item }">
        <v-btn link text :href="item.marketUrl + '/dp/' + item.asin" target="_blank" color="primary">
          {{ item.asin }}
        </v-btn>
      </template>
      <template v-slot:item.unitPrice="{ item }">
        <label>{{ item.itemPrice | div(item.sales) }}</label>
      </template>
    </v-data-table>
    <today-filter date-range :visible.sync="filterDialog" :params="params" @reload="getData"/>
  </div>
</template>

<script>
import TodayFilter from "@/page/Today/TodayFilter";

export default {
  name: "ProductDiary",
  components: {TodayFilter},
  data() {
    return {
      loading: true,
      headers: [
        {text: "图片", align: "center", sortable: false, value: "productImageUrl"},
        {text: "店铺", align: "center", sortable: false, value: "storeName"},
        {text: "ASIN", align: "center", sortable: false, value: "asin"},
        {text: "SKU", align: "center", sortable: false, value: "sku"},
        {text: "日期", align: "center", value: "diaryDate"},
        {text: "销量", align: "center", value: "sales"},
        {text: "订单数", align: "center", sortable: false, value: "orders"},
        {text: "已支付", align: "center", sortable: false, value: "payed"},
        {text: "已取消", align: "center", sortable: false, value: "canceled"},
        {text: "已换货", align: "center", sortable: false, value: "replaced"},
        /*{text: "净销售额", align: "center", sortable: false, value: "itemPrice"},
        {text: "单价", align: "center", sortable: false, value: "unitPrice"}*/
      ],
      items: [],
      params: {
        options: {
          sortBy: ["diaryDate", "sales"],
          sortDesc: [true, true]
        },
        filters: {
          search: this.$route.params.sku ? this.$route.params.sku : null,
          marketplaces: [],
          stores: [],
          asins: [],
          skus: [],
          beginTime: null,
          endTime: null
        },
        total: null
      },
      filterDialog: false,
      marketplaces: [],
      stores: [],
      asins: [],
      skus: [],
      isCount: false,
      count: {
        sales: 0,
        orders: 0,
        payed: 0,
        canceled: 0,
        replaced: 0
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.items = []
      this.params.total = 0
      this.$axios.post("/products/diary", this.params).then(
          response => {
            this.items = response.data.list;
            this.params.total = response.data.total;
            this.loading = false;
            console.debug("productDiaries: ", this.items);
          }
      );
      this.countData();
    },
    countData() {
      this.count.sales = 0;
      this.count.orders = 0;
      this.count.payed = 0;
      this.count.canceled = 0;
      this.count.replaced = 0;
      this.isCount = this.params.filters.beginTime || this.params.filters.endTime;
      if (this.isCount) {
        this.$axios.post("/products/diary/summary", this.params.filters).then(
            response => {
              this.isCount = true;
              if (response.data) {
                this.count = response.data;
              }
            }
        );
      }
    },
    openFilterDialog() {
      this.filterDialog = true;
    },
    clear() {
      setTimeout(function () {
        this.getData();
      }.bind(this), 300);
    },
  }, watch: {
    "params.options": {
      deep: true,
      handler() {
        console.log("这次的options是: " + JSON.stringify(this.params.options));
        this.items = [];
        this.getData();
      }
    }
  }
}
</script>

<style scoped>
</style>